// Language to Country mapping for auto-currency selection
const LANGUAGE_TO_COUNTRY_MAP = {
  'en': 'US',   // English → United States → USD
  'de': 'DE',   // German → Germany → EUR
  'es': 'ES',   // Spanish → Spain → EUR
  'fr': 'FR',   // French → France → EUR
  'it': 'IT',   // Italian → Italy → EUR
  'ar': 'AE'    // Arabic → United Arab Emirates → AED
};

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure_element'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
 
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const selectedValue = event.currentTarget.dataset.value;
    this.elements.input.value = selectedValue;

    // Check if this is a language form (has locale_code input)
    const isLanguageForm = this.elements.input.name === 'locale_code';

    if (isLanguageForm) {
      // Check if user has manually overridden country selection
      const hasManualOverride = sessionStorage.getItem('figuro_manual_country_override') === 'true';

      // Look up default country for this language
      const defaultCountry = LANGUAGE_TO_COUNTRY_MAP[selectedValue];

      // Only auto-switch currency if no manual override and mapping exists
      if (defaultCountry && !hasManualOverride) {
        // Add country_code to the existing form if it doesn't have one
        let countryInput = form.querySelector('input[name="country_code"]');
        
        if (!countryInput) {
          // Create and add country input to existing form
          countryInput = document.createElement('input');
          countryInput.type = 'hidden';
          countryInput.name = 'country_code';
          form.appendChild(countryInput);
        }
        
        // Set the country value
        countryInput.value = defaultCountry;
        
        // Submit the original Shopify form with both values
        form.submit();
        return; // Exit early - we're submitting the form
      }
    } else {
      // User manually changed country - set override flag
      sessionStorage.setItem('figuro_manual_country_override', 'true');
    }

    // Default behavior for non-language forms or when no mapping exists
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);